// @flow

import React from 'react';
import ActiveItem from '../activeItem';
import type { ExtraContract } from '../../../../../../types/pdb';

type Props = {|
  active: ExtraContract,
  price: number,
|};

export default ({ active, price, ...props }: Props) => (
  <ActiveItem
    type=""
    title={active.name}
    price={price}
    {...props}
  />
);
